import { render } from "./ResetPasswordForm.vue?vue&type=template&id=19c54d21&ts=true"
import script from "./ResetPasswordForm.ts?vue&type=script&lang=ts&external"
export * from "./ResetPasswordForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__